import { BAC_COLORS } from '@ezugi/constants';

const {
  PLAYER_COLOR, BANKER_COLOR,
  DRAGON_COLOR, TIGER_COLOR,
  BOWLER_COLOR, BATSMAN_COLOR,
  TIE_COLOR,
} = BAC_COLORS;

const customPlayerColors = { 24: DRAGON_COLOR, 45: BOWLER_COLOR };
const customBankerColors = { 24: TIGER_COLOR, 45: BATSMAN_COLOR };

export const getColor = (gameId, winningHand) => ({
  Player: customPlayerColors[gameId] || PLAYER_COLOR,
  Banker: customBankerColors[gameId] || BANKER_COLOR,
  Tie: TIE_COLOR,
}[winningHand]);
